import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const Carousel = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      image: "https://images.unsplash.com/photo-1584622650111-993a426fbf0a?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80",
      title: "Professional Carpet Cleaning",
      description: "Experience the difference with our eco-friendly cleaning solutions",
      buttonText: "Book Now",
      buttonLink: "/booking"
    },
    {
      image: "/images/slide1-1.jpg",
      title: "Eco-Friendly Solutions",
      description: "Green cleaning products that are safe for your family and pets",
      buttonText: "Our Services",
      buttonLink: "/services"
    },
    {
      image: "/images/slide1-2.jpg",
      title: "Satisfaction Guaranteed",
      description: "We stand behind our work with a 100% satisfaction guarantee",
      buttonText: "Learn More",
      buttonLink: "/about"
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [slides.length]);

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  return (
    <div className="carousel">
      {slides.map((slide, index) => (
        <div
          key={index}
          className={`carousel-slide ${index === currentSlide ? 'active' : ''}`}
        >
          <img src={slide.image} alt={slide.title} className="carousel-image" />
          <div className="carousel-content">
            <h2>{slide.title}</h2>
            <p>{slide.description}</p>
            <Link to={slide.buttonLink} className="carousel-btn">
              {slide.buttonText}
            </Link>
          </div>
        </div>
      ))}
      
      <div className="carousel-indicators">
        {slides.map((_, index) => (
          <div
            key={index}
            className={`indicator ${index === currentSlide ? 'active' : ''}`}
            onClick={() => goToSlide(index)}
          />
        ))}
      </div>
    </div>
  );
};

export default Carousel;